// TODO: add syntax validation for these python code snippets
export const TRANSITION_FUNCTION_CODE = {
  TRANSITION_TO_END_STEP: `def transition_to_end_step(conv: Conversation, flow: Flow, name: str):
    if not name:
        return "Please ask the user for their name and then call this function again."

    conv.state.name = name
    flow.goto_step("End step")`,

  EXIT_FLOW: `def exit_flow(conv: Conversation, flow: Flow):
    conv.exit_flow()`,
} as const;
